var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 10.3333H11.3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 12.6666H9.99999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91534 4.16667C6.91534 4.47609 7.03826 4.77283 7.25705 4.99162C7.47585 5.21042 7.77259 5.33333 8.08201 5.33333C8.39143 5.33333 8.68818 5.21042 8.90697 4.99162C9.12576 4.77283 9.24868 4.47609 9.24868 4.16667C9.24868 3.85725 9.12576 3.5605 8.90697 3.34171C8.68818 3.12292 8.39143 3 8.08201 3C7.77259 3 7.47585 3.12292 7.25705 3.34171C7.03826 3.5605 6.91534 3.85725 6.91534 4.16667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.33329V7.33329C6 7.33329 6.74847 6.66663 8.0818 6.66663C9.41513 6.66663 10.1636 7.33329 10.1636 7.33329V8.33329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0.666626H2V15.3333H14V3.99996L10.6667 0.666626Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.b67af880.svg";
export { ForwardRef as ReactComponent };